import styles from './CartRow.module.scss'
import React from 'react'
import { Roboto } from "next/font/google"
import classNames from 'classnames'
import CartColumn from '../CartColumn/CartColumn'
import CrossIcon from '@/assets/svg/cross.svg'

export type ColumnSettings = {
  label?: string
  value?: any
  textAlign?: 'left' | 'right' | 'center'
}

type Props = {
  columns: ColumnSettings[],
  showRemoveButton?: boolean
  onClickRemove?: () => void,
  children?: any,
}

const roboto = Roboto({
  subsets: ['latin'],
  weight: ['700'],
})

const CartRow = (props: Props) => {
  const columns = props.columns

  return (
    <div className={classNames(styles.component, roboto.className, 'row')}>
      <CartColumn className="col-xs-1" textAlign={columns[0].textAlign}>
        <label>{columns[0].label}</label>
        <div>{columns[0].value}</div>
      </CartColumn>
      <CartColumn className="col-xs-1" textAlign={columns[1].textAlign}>
        <label>{columns[1].label}</label>
        <div>{columns[1].value}</div>
      </CartColumn>
      <CartColumn className="col-xs" textAlign={columns[2].textAlign}>
        <label>{columns[2].label}</label>
        <div>{columns[2].value}</div>
      </CartColumn>
      {/* Optional, usally for referense */}
      {columns[3].label && (
        <CartColumn className="col-xs-2" textAlign={columns[3].textAlign}>
          <label>{columns[3].label}</label>
          <div>{columns[3].value}</div>
        </CartColumn>
      )}
      <CartColumn className="col-xs-1" textAlign={columns[4].textAlign}>
        <label>{columns[4].label}</label>
        <div>{columns[4].value}</div>
      </CartColumn>
      <CartColumn className="col-xs-1" textAlign={columns[5].textAlign}>
        <label>{columns[5].label}</label>
        <div>{columns[5].value}</div>
      </CartColumn>
      <CartColumn className="col-xs-1" textAlign={columns[6].textAlign}>
        <label>{columns[6].label}</label>
        <div>{columns[6].value}</div>
      </CartColumn>
      {props.showRemoveButton && (
        <button className={styles.removeButton} onClick={props.onClickRemove}>
          <CrossIcon />
        </button>
      )}
      {props.children && (
        <div className={classNames('col-xs-12')}>
          {props.children}
        </div>
      )}
    </div>
  )
}

export default CartRow